export const SearchTypeForSearchSalesMastList = {
	all: "all",
	infoReservation: "infoReservation",
	infoEC: "infoEC",
	infoTicketBasic: "infoTicketBasic",
	infoTicketPro: "infoTicketPro",
} as const;

export type SearchTypeForSearchSalesMastList =
	(typeof SearchTypeForSearchSalesMastList)[keyof typeof SearchTypeForSearchSalesMastList];
